import { useRecoilValue } from "recoil";
import useSWR from "swr";
import { ifreaMediaAnalyticsDateRangeState } from "../../store/ifreaMediaAnalyticsDateRangeState";

export const useFetchGurunaviAnalytics = (restaurantId?: string) => {
  const dateRange = useRecoilValue(ifreaMediaAnalyticsDateRangeState)
  const fetcherKey = restaurantId ? `ifrea_analytics/restaurants/${restaurantId}/gurunavi-analytics/?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}` : null;
  const { data: gurunaviAnalytics, isLoading } = useSWR<any>(fetcherKey)
  return { gurunaviAnalytics, isLoading };
};